module.exports = __webpack_public_path__ + "static/img/Team 3.1b7d8aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hr/Team 3.png
// module id = 5AR3
// module chunks = 2